import React from 'react';
import { Users, UserCheck, UserX, Clock } from 'lucide-react';

const UtilisateurStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Utilisateurs',
      value: stats?.total_users || 0,
      icon: Users,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
      gradient: 'from-blue-500 to-blue-600'
    },
    {
      title: 'Comptes Actifs',
      value: stats?.active_users || 0,
      icon: UserCheck,
      color: 'text-green-600',
      bgColor: 'bg-green-100',
      gradient: 'from-green-500 to-green-600'
    },
    {
      title: 'Comptes Inactifs',
      value: stats?.inactive_users || 0,
      icon: UserX,
      color: 'text-red-600',
      bgColor: 'bg-red-100',
      gradient: 'from-red-500 to-red-600'
    },
    {
      title: 'Nouveaux (7 jours)',
      value: stats?.new_users_week || 0,
      icon: Clock,
      color: 'text-purple-600',
      bgColor: 'bg-purple-100',
      gradient: 'from-purple-500 to-purple-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {statCards.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div 
            key={index} 
            className={`bg-gradient-to-br ${stat.gradient} rounded-xl shadow-lg p-6 text-white transform hover:scale-105 transition-transform duration-200`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-white text-opacity-90 text-sm font-medium mb-1">
                  {stat.title}
                </p>
                <p className="text-4xl font-bold mb-2">{stat.value}</p>
              </div>
              <div className="bg-white bg-opacity-20 p-4 rounded-lg">
                <Icon className="w-8 h-8" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UtilisateurStats;
